import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { styled } from "@mui/material/styles";
import styles from "../assets/jss/material-dashboard-react/components/cardIconStyle.js";

// Styled root div
const CardIconRoot = styled("div", {
  shouldForwardProp: (prop) => !["color"].includes(prop),
})(({ color }) => ({
  ...styles.cardIcon,
  ...(color && styles[`${color}CardHeader`]),
}));

export default function CardIcon(props) {
  const { className, children, color, ...rest } = props;

  return (
    <CardIconRoot
      className={classNames(className)}
      color={color}
      {...rest}
    >
      {children}
    </CardIconRoot>
  );
}

CardIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose"
  ]),
  children: PropTypes.node
};
